import { render, staticRenderFns } from "./hero-section.vue?vue&type=template&id=2237bfd4&"
import script from "./hero-section.vue?vue&type=script&lang=js&"
export * from "./hero-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports